import { SET_LOADING_HEADER } from 'utils/fetcher/contants';
import { API_VALIDARFOTO, APP_CLIENT_ID, APP_CLIENT_SECRET } from 'variables';
import { ResponseFetcher } from 'utils/fetcher/types';
import fetcher, { paramsFormer } from 'utils/fetcher';

export const getPhotosRequest = async (
  requestBody: any /* GetPhotosRequest*/
  // token: string,
): Promise<ResponseFetcher<any /*Photo[]*/>> =>
  fetcher({
    url: `${API_VALIDARFOTO}getFotosPerfil?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });
export const getPhotosCountRequest = async (
  requestBody: any
): Promise<ResponseFetcher<any>> =>
  fetcher({
    url: `${API_VALIDARFOTO}getFotosPerfilCount?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getFilterAlumnoValidationRequest = async (
  requestBody: any,
  token: string
): Promise<ResponseFetcher<any>> =>
  fetcher({
    url: `${API_VALIDARFOTO}getUsuariosFotoPerfil?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

export const postRejectPhotoRequest = (
  requestBody: any,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_VALIDARFOTO}rechazarFotoPerfil`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

export const postValidPhotoRequest = (
  requestBody: any,
  token: string
): Promise<ResponseFetcher<null>> =>
  fetcher({
    url: `${API_VALIDARFOTO}validarFotoPerfil`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });
